export default __webpack_public_path__ + "static/media/et-am.bfa08d4d.svg";